import React from "react";
import { SimpleGrid, type SpaceProps } from "@chakra-ui/react";
import { Section } from "components/section";
import { type WarehouseConfig } from "contexts/warehouse-cdp-context";
import { TextTitle } from "ui/text";
import { Card, HorizontalCard } from "ui/cards";
import seventhCardImage from "../../../../public/assets/platform-overview-content/data-teams-card-7.png";
import { getCards } from "./cards";

type DataTeamsCardsProps = {
  hasHorizontalCard?: boolean;
  warehouse?: WarehouseConfig;
} & SpaceProps;

function DataStackHorizontalCard() {
  return (
    <HorizontalCard
      mt={{ base: "biggest", md: "big" }}
      mx="auto"
      title="Connected to your whole data stack"
      description="Hightouch integrates with the tools you already use for data observability, lineage, orchestration, business intelligence, ETL, and more."
      image={{
        src: seventhCardImage,
        alt: "Image featuring logos for Airflow, Dagster, Fivetran, dbt, Sigma, Looker, Tableau, and Datadog",
      }}
    />
  );
}

export function DataTeamsCards({ hasHorizontalCard, warehouse, ...spaceProps }: DataTeamsCardsProps) {
  const cards = getCards(warehouse);

  return (
    <Section {...spaceProps}>
      <TextTitle align="center" size="lg" title="Built for modern data teams" />
      <SimpleGrid
        justifyItems={{ base: "center", md: "auto" }}
        columns={{ base: 1, md: 2, lg: 3 }}
        gap={{ base: "biggest", md: "small" }}
        mt={{ base: "biggest", md: "huge" }}
      >
        {cards.map((card) => (
          <Card key={card.id} variant="inline" mediaRatio={424 / 300} {...card} />
        ))}
      </SimpleGrid>
      {hasHorizontalCard && <DataStackHorizontalCard />}
    </Section>
  );
}
